import schoolSearchDirective from 'html/claim/school-search-directive.html';
import App from 'app/app.js';
import 'app/directive/LtSchoolSearchCtrl.js';

function LtSchoolSearchDirective() {
  return {
    restrict: 'E',
    scope: {
      isFindMyPictureDay: '=',
      selectedAccount: '=',
      showHideFindMyPictureDay: '&',
      onCancel: '&',
      onContinue: '&',
      fromBannerPage: '=',
      fromConfirmExistingStudentPopup: '='
    },
    template: schoolSearchDirective,
    controller: 'LtSchoolSearchCtrl',
    controllerAs: 'schoolSearch'
  };
}

App.directive('ltSchoolSearch', [LtSchoolSearchDirective]);
